<script>
	import { getText } from '../../../../share/utils';
</script>

<div class="page-menschen_bewegen-beratung marginbox">
	<div class="flex structure">
		<div class="flex row structure-1">
			<div class="flex element">
				<div class="text">
					<h2 class="caption">{getText("12.06.01_h2")}</h2>
					<p class="caption">{getText("12.06.02_caption")}</p>
				</div>
			</div>
			
			<div class="flex element">
				<img loading="lazy" alt="Menschen bewegen - Guideline-Design" src="./../img/12.Menschen_Bewegen/06.beratung/guideline.webp">
			</div>
		</div>
	</div>
</div>

<style lang="scss">
	@import "../../../../style/mixins";
	@import "../../../../style/variables";
	
	img {
		width: 100%;
		margin: 0;
		padding: 0;
	}
	
	.img-single {
		margin: $spacing-mobile 0 $media-gap 0;
	}
	
	.page-menschen_bewegen-beratung {
		.flex {
			display: flex;
			box-sizing: border-box;
		}
		
		.row {
			flex-flow: row wrap;
		}
		
		.col {
			flex-flow: column wrap;
		}
		
		.element {
			min-width: 100px;
		}
		
		.commercial {
			position: relative;
			width: 100%;
			height: 100%;
		}
		
		.content {
			flex: 1 100%;
		}
		
		.structure {
			flex-flow: row wrap;
		}
		
		.structure-1 {
			width: 100%;
			padding: 0;
			position: relative;
			
			> .element {
				width: 100%;
				margin-bottom: $media-gap;
				height: fit-content;
			}
		}
		
		.text {
			margin: 0;
		}
	}
</style>
